var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showMessage)?_c('b-message',{attrs:{"title":_vm.landingTitle,"type":_vm.landingType,"has-icon":"","closable":false}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.landingMessage)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }